import { combineReducers } from 'redux';
import { dmaGroupCodes } from './dmaGroupCode';
export default combineReducers({ dmaGroupCodes });
